// import Tip from '../components/Tip';
import { TipHOC } from 'routes/Checkout/containers/TipContainer';
import Tip from 'routes/Checkout/components/Tip';

export default TipHOC(Tip);
